export default angular
  .module("CodeSystemListCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("CodeSystemListController", [
    "$scope",
    "$location",
    "$rootScope",
    "CodeSystem",
    function (
      $scope,
      $location,
      $rootScope,
      CodeSystem,
    ) {
      $rootScope.codeSystemPageSize = $rootScope.codeSystemPageSize || 20;
      $scope.searchString = $rootScope.codeSystemListFilter;
      $scope.sortCodeSystems = {
        column: "NAME",
        direction: false,
      };
      $scope.currentPage = $rootScope.codeSystemListPage || 1;

      const setPage = (page) => {
        $scope.currentPage = page;
        $rootScope.codeSystemListPage = page;
      };

      $scope.filterChanged = function () {
        $rootScope.codeSystemListFilter = $scope.searchString;
        setPage(1);
      };

      $scope.pageChanged = setPage;

      $scope.codeSystems = [];
      $scope.loading = CodeSystem.loading;
      CodeSystem.loadCodeSystems((codeSystems) => {
        $scope.codeSystems = codeSystems;
      });

      $scope.openCodeSystemURL = (id) => {
        $location.path(`/code-system/${id}`);
      };

      $scope.changeSorting = (column) => {
        if ($scope.sortCodeSystems.column === column) {
          $scope.sortCodeSystems.direction = !$scope.sortCodeSystems.direction;
        } else {
          $scope.sortCodeSystems.column = column;
          $scope.sortCodeSystems.direction = false;
        }
      };
    },
  ]);
